import { axiosInstance as axios } from "services";

export const initiateGlobalPriceChange = async (body) => {
  const { data } = await axios.post("/admin/subscription/global-price-change", body);
  if (!data.success) throw new Error(data.error?.message || "Failed to initiate global price change");
  return data;
};

